<template>
  <div class="logistics-wrap">
    <ul class="list-wrap">
      <li v-for="(item, index) in list" :key="index">
        <div class="info-row">
          <p>
            <label>物流单号：</label>
            <template v-if="item.logistics_no">
              <span>{{ item.logistics_no }}</span>
              <span
                v-if="$store.state.commonSetting.logistics_switch == 1"
                class="btn"
                @click="onWatchLogistics(item.logistics_no)"
              >
                查看物流
              </span>
            </template>
            <span v-else>待揽收</span>
          </p>
          <p>
            <label>收货人：</label>
            <span>{{ item.consignee }}</span>
          </p>
        </div>
        <div class="info-row">
          <p>
            <label>物流公司：</label>
            <span>
              {{ item.logistics_name }}
            </span>
          </p>
          <p>
            <label>手机号码：</label>
            <span>{{ item.mobile }}</span>
          </p>
        </div>
        <div class="info-row">
          <p>
            <label>收货地址：</label>
            <span>
              {{ item.province_name + item.city_name + item.district_name + item.address }}
            </span>
          </p>
          <p>
            <label>物料内容：</label>
            <span :title="item.material_content" class="material-content">
              {{ item.material_content }}
            </span>
          </p>
        </div>
      </li>
    </ul>
    <div class="btn-expand-wrap" v-if="logistics.length > 3">
      <p :disabled="expand" @click="expand = true">
        展开
        <i class="el-icon-arrow-down"></i>
      </p>
      <p :disabled="!expand" @click="expand = false">
        收起
        <i class="el-icon-arrow-up"></i>
      </p>
    </div>
    <MemberOrderDelivery
      :visible.sync="showLogisticsDetail"
      :list="logisticsDetailList"
    ></MemberOrderDelivery>
  </div>
</template>

<script>
import MemberOrderDelivery from './MemberOrderDelivery.vue';
export default {
  name: 'MemberOrderLogistics',
  components: { MemberOrderDelivery },
  props: {
    logistics: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      expand: false,
      showLogisticsDetail: false,
      logisticsDetailList: [],
    };
  },
  computed: {
    list() {
      return this.expand ? this.logistics : this.logistics.slice(0, 3);
    },
  },
  methods: {
    async onWatchLogistics(logisticsNo) {
      const data = await this.$http.get(`/api/app/logistics/${logisticsNo}`);
      this.logisticsDetailList = data.data;
      this.showLogisticsDetail = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.logistics-wrap {
  margin-bottom: 32px;
}
.list-wrap {
  border: 1px solid #e6e6e6;
  color: #333;
  li {
    margin: 0 20px;
    padding: 20px 0;
    border-bottom: 1px solid #e6e6e6;
    &:last-of-type {
      border-bottom: none;
    }
    .info-row {
      display: flex;
      margin-bottom: 8px;
      &:last-of-type {
        margin-bottom: 0;
      }
      p {
        width: 50%;
        display: flex;
        align-items: center;
        label {
          flex-shrink: 0;
          color: #999;
        }
        .material-content {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .btn {
          color: $primary-color;
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
    .info-row.fill p {
      width: auto;
    }
  }
}
.btn-expand-wrap {
  display: flex;
  justify-content: center;
  padding-top: 16px;
  p {
    width: 72px;
    height: 28px;
    border-radius: 15px;
    border: 1px solid #e6e6e6;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    margin: 0 4px;
    cursor: pointer;
    &[disabled] {
      color: #ccc;
      cursor: not-allowed;
    }
  }
}
</style>
